import React, { useEffect, useState } from 'react';
import '../../../css/weekly-calendar.css';
import { AddUpdate } from '../../../ApiMethods/ApiMethods'; 

const weekdays = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];

const getDatesForWeek = () => {
  const start = new Date();
  return Array.from({ length: 7 }).map((_, i) => {
    const d = new Date(start);
    d.setDate(start.getDate() + i); 
    return d.toLocaleDateString('en-GB', {
      day: 'numeric',
      month: 'short',
    });
  });
};


const weekdaysWithDates = weekdays.map((day, i) => ({
  day,
  date: getDatesForWeek()[i],
}));

const statusColors = {
  Online: 'slot-available',
  Offline: 'slot-leave',
  Booked: 'slot-booked',
};

const WeeklyCalendar = () => {
  const [hoverInfo, setHoverInfo] = useState(null);
  const [astroData, setAstroData] = useState([]); 
  const [loading, setLoading] = useState(true);

  const timetabledata = async () => {
    try {
      const res = await AddUpdate('Astrologer/Astrotimeslot');
      const data=JSON.parse(res?.data?.data);
      const final=data?.Table;
    

     
      if (Array.isArray(final)) {
        setAstroData(final);
      } else if (final) {
       
        const parsed = typeof final === 'string' ? JSON.parse(final) : final;
        setAstroData(Array.isArray(parsed) ? parsed : []);
      } else {
        setAstroData([]);
      }
    } catch (error) {
      console.error('Error fetching timetable data:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    timetabledata();
  }, []);

  const renderAstrologerRow = (astro) => {
    return (
      <tr key={astro.AstroId}>
        <td className="astrologer-details">
          <div className="astrologer-name">{astro.AstroName}{`(${astro.AstroId})`}</div>
        </td>

     {Object.keys(astro)
  .filter((key) => key.includes('(')) 
  .map((key) => {
    const status = astro[key];

   
    const timeSlots = status?.includes(',')
      ? status.split(',').map((t) => t.trim())
      : [status];

    return (
      <td key={key} className="calendar-cell">
        {timeSlots.map((slot, idx) => {
        
          const colorClass = slot.includes(':')
            ? 'slot-available' 
            : statusColors[slot] || 'slot-leave'; 

          return (
            <div
              key={idx}
              className={`time-slot ${colorClass}`}
              onMouseEnter={() => setHoverInfo(`${slot.toUpperCase()}`)}
              onMouseLeave={() => setHoverInfo(null)}
            >
              {slot}
            </div>
          );
        })}
      </td>
    );
  })}

      </tr>
    );
  };

  return (
    <div className="weekly-calendar">
      <h2 className="calendar-header">Astrologers Weekly Calendar</h2>

      {loading ? (
        <p>Loading...</p>
      ) : (
        <div className="calendar-container">
          <table className="calendar-grid">
            <thead>
              <tr>
                <th className="calendar-header-cell">Details</th>
                {weekdaysWithDates.map(({ day, date }) => (
                  <th key={day} className="calendar-header-cell">
                    <div>{day}</div>
                    <small>{date}</small>
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {astroData.length > 0 ? (
                astroData.map(renderAstrologerRow)
              ) : (
                <tr>
                  <td colSpan="8" className="text-center">
                    No data available
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      )}

      {hoverInfo && <div className="hover-tooltip">{hoverInfo}</div>}
    </div>
  );
};

export default WeeklyCalendar;
